import { LocationIcon } from '@/components/ui/icons';
import BrushIcon from '@/components/ui/icons/brush-icon';
import DeleteOutlineIcon from '@/components/ui/icons/delete-outline-icon';
import ImportIcon from '@/components/ui/icons/import-left';
import LinkIcon from '@/components/ui/icons/link-icon';
import { ADDRESS_MODES, SHIPPING_INFO_MODALS_NAMES } from '@/constants';
import { event_address_option_selected } from '@/utils/gtm';
import { useTranslations } from 'next-intl';

const AddAddressOptionsModal = ({
  setModalStep,
  setAddressType,
  addressType,
}) => {
  const handleSelectAddressType = (type) => {
    setAddressType(type);
    setModalStep(SHIPPING_INFO_MODALS_NAMES.ADD_EDIT_ADDRESS);
    event_address_option_selected({
      value: type === 'nation' ? 'national_address' : type,
    });
  };

  return (
    <>
      <div className='px-[29px] pt-[14px] max-sm:px-1.75'>
        <div className='flex flex-col gap-[17px] py-5'>
          <HomeDeliveryAddressCard
            title='Detect My Location Automatically'
            subTitle='We will use your current location to auto-fill the address'
            Icon={LocationIcon}
            deliveryAddressType={ADDRESS_MODES.AUTO}
            handleSelectAddressType={handleSelectAddressType}
            addressType={addressType}
          />

          <HomeDeliveryAddressCard
            // disabled={true}
            title='National Address (Mobile / NAID Number)'
            subTitle='Enter your mobile number or national address ID to retrieve your address automatically'
            Icon={LinkIcon}
            deliveryAddressType={ADDRESS_MODES.NATIONAL}
            handleSelectAddressType={handleSelectAddressType}
            addressType={addressType}
          />

          <HomeDeliveryAddressCard
            title='Enter Address Manually'
            subTitle='Fill in the fields yourself if you don’t have National Address information available'
            Icon={BrushIcon}
            deliveryAddressType={ADDRESS_MODES.Manual}
            handleSelectAddressType={handleSelectAddressType}
            addressType={addressType}
          />
        </div>
      </div>
    </>
  );
};

export default AddAddressOptionsModal;

export const HomeDeliveryAddressCard = ({
  title,
  subTitle = '',
  handleSelectAddressType,
  addressType,
  deliveryAddressType,
  Icon,
  disabled = false,
}) => {
  const t = useTranslations('modals');

  return (
    <div
      onClick={() =>
        disabled ? null : handleSelectAddressType(deliveryAddressType)
      }
      className={`relative flex h-[5.313rem] cursor-pointer items-center justify-between rounded-[10px] border px-[19px] ${deliveryAddressType === addressType ? 'border-primary' : 'border-[#D9D9D9]'}`}
    >
      {disabled ? (
        <div className='absolute end-2 top-2 rounded-full bg-red-500 px-3 pt-1.5 pb-1 text-xs text-white'>
          {t('soon')}
        </div>
      ) : null}
      <div
        className={`flex h-full items-center gap-[16px] ${disabled ? 'opacity-40' : ''}`}
      >
        <div className='flex h-12 w-12 items-center justify-center rounded-full bg-[#F2F3F5]'>
          {Icon && <Icon className='h-[27px] w-[27px]' />}
        </div>

        <div>
          <h3 className='mb-[7px] text-[16px] font-bold max-sm:text-sm'>
            {t(title)}
          </h3>
          {subTitle && <p className='text-sm max-sm:text-xs'>{t(subTitle)}</p>}
        </div>
      </div>
      {deliveryAddressType === 'home' && (
        <div className='flex items-center gap-[22px]'>
          <ImportIcon />
          <DeleteOutlineIcon />
        </div>
      )}
    </div>
  );
};
